import { useContext, useState } from "react";
import DisplayElementsModal from "../../../../components/layouts/declarations/DisplayElementsModal/DisplayElementsModal";
import { handleValidationErrorsView } from "../../../../context/declaration/validations";
import NotificationItem from "./NotificationItem";
import DeclarationContext from "../../../../context/declaration/DeclarationContext";
import LoadingSpinner from "../../../../components/common/LoadingSpinner";

const Notifications = ({ isLoading }) => {
	const [isDisplayElementsModalOpen, setIsDisplayElementsModalOpen] = useState(false);
	const [selectedNotification, setSelectedNotification] = useState();
	const { state } = useContext(DeclarationContext);

	const getNotificationClickAction = (notification) => {
		if (notification.type === "validationError") {
			return () => handleValidationErrorsView(notification);
		} else if (notification.elements && Object.keys(notification.elements)) {
			return () => {
				setIsDisplayElementsModalOpen(true);
				setSelectedNotification(notification);
			};
		}

		return null;
	};

	return (
		<>
			<DisplayElementsModal
				open={isDisplayElementsModalOpen}
				elements={selectedNotification?.elements || {}}
				onClose={() => setIsDisplayElementsModalOpen(false)}
			/>

			<div style={{ marginTop: 20 }}>
				{isLoading ? (
					<LoadingSpinner />
				) : (
					state.notifications.map((notification, index) => {
						const clickHandler = getNotificationClickAction(notification);

						return (
							<NotificationItem
								key={index}
								notification={notification}
								onClick={clickHandler}
							/>
						);
					})
				)}
			</div>
		</>
	);
};

export default Notifications;
